import axios from 'axios';
import { Message } from 'element-ui';
import ApiConfig from '@/api-config';
import { EventBus } from '../utils/event-bus'
import store from '@/vuex';

import qs from 'qs';
//基础请求
function BaseRequest(options) {
    return new Promise((resolve, reject) => {
        //基础设置
        const instance = axios.create({
            baseURL: window.myIPconfig.baseURL,
            timeout: 300000, //超时时间
            withCredentials: true, //是否携带cookie
            responseType: 'json', //响应的数据类型
            headers: { //定义请求头
                // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                // 'X-Requested-With': 'XMLHttpRequest',
                'Accept-Language':localStorage.getItem('changeLang')
            }
        });
        //请求拦截
        instance.interceptors.request.use(config => {
                if (config.method === 'post' || config.method === 'put') {
                    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
                }
                let token = localStorage.getItem('USER_TOKEN')
                if (token) {
                    config.headers['user-token'] = localStorage.getItem('USER_TOKEN')
                }
                return config;
            }, error => {
                Message.error({
                    message: '加载超时',
                    type: 'error',
                    duration: 10 * 1000
                });
                return Promise.reject(error)
            })
            //响应拦截
        instance.interceptors.response.use(response => {
            // if(response.data.result !== null
            //     && typeof(response.data.result) !== 'undefined'
            //     && typeof(response.data.result.return_content) !== 'undefined'
            //     && response.data.result.return_content !== null
            //     && typeof(response.data.result.return_content.error_desc) !== 'undefined'){
            //     if(response.data.result.return_content.error_desc ==="TMS_SESSION_TIMEOUT"){
            //         EventBus.$emit("logOut", "会话超时，退出登陆");//触发退出事件
            //     }else if(response.data.result.return_content.error_desc === "TMS_UKEY_INVALID"){
            //         EventBus.$emit("logOutUser", "Ukey无效，退出登陆");//触发退出事件
            //     }else if(response.data.result.return_content.error_desc === "TMS_AUTHORIZATION_INVALID"){
            //         EventBus.$emit("goToAuthorizationManagement", "授权无效，跳转到授权页面");//触发退出事件
            //     }
            // }
            return response;
        }, error => {
            Message({
                message: '加载超时,请重试',
                type: 'error',
                duration: 10 * 1000,
            });
            // if (error.response.status === 302) {
            //     // window.location.href = error.response.headers.Location;
            //
            // } else if (error.response === undefined || error.response.status === undefined) {
            //     Message({
            //         message: '连接服务器失败!',
            //         type: 'error',
            //         duration: 10 * 1000,
            //         showClose: true,
            //     });
            // } else if (error.response.status === 401 || error.response.status === 412) {
            //     Message({
            //         message: '加载超时!',
            //         type: 'error',
            //         duration: 10 * 1000,
            //     });
            // } else {
            //     Message({
            //         message: error.message,
            //         type: 'error',
            //         duration: 10 * 1000,
            //         showClose: true,
            //     })
            // };
            return Promise.reject(error) // 错误信息
        });
        //请求处理
        instance(options).then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                reject(error)
            })
    });
};
//JSON传参

//基础POST请求
function RequestPost(url, data) {
    // if (data.message_id !== 'b6aa379682254d1793433c7e4c91e97c') {
    //     data.sessionid = window.sessionStorage.getItem('sessionId');
    // }
    return BaseRequest({
        method: 'POST',
        url: url,
        data,
    });
};
const invokeRemoteMethod = (option) => {
    let url = ApiConfig.invokeRemoteMethod;
    return RequestPost(url, option)
};

//基础GET请求
function RequestGet(url, params) {
    return BaseRequest({
        method: 'GET',
        url: url,
        params,
    });
}

let fileUp = () => {
    let fileUpApi = axios.create({
        baseURL: window.myIPconfig.baseURL, // 从环境进程中根据运行环境获取的api的base_url
        timeout: 60 * 1000, // 请求超时时间
        // timeout: 240000, // 请求超时时间
    });

    //返回拦截
    fileUpApi.interceptors.request.use(
        response => {
            return response
        },
        error => {
            if (error.response === undefined || error.response.status === undefined) {
                Message({
                    message: '服务器繁忙，请稍后重试!',
                    type: 'error',
                    duration: 2 * 1000,
                    showClose: true,
                });
            } else if (error.response.status === 401 || error.response.status === 412) {
                Message({
                    message: '加载超时!',
                    type: 'error',
                    duration: 2 * 1000,
                });
            } else {
                Message({
                    message: error.message,
                    type: 'error',
                    duration: 5 * 1000
                })
            }
        }
    );
    return fileUpApi;
}


export default {
    invokeRemoteMethod,
    RequestGet,
    fileUp,
    RequestPost
}



// WEBPACK FOOTER //
// ./src/api/request.js